module.exports = __webpack_public_path__ + "media/landing_page/flexibility-72fa7137.png";